import { TransText } from '@/i18n/trans/text';
import { Button, Icons, Typography } from '@packages/webshop-design-system';
import type { FC } from 'react';

interface ConfigLoadErrorProps {
  onRetry: () => void;
}

/**
 * App-level fallback shown when the sales-point configuration fails to load.
 * The config is a hard dependency for the whole app (field visibility,
 * pricing, etc.), so rather than render config-dependent pages half-baked we
 * block with a retry instead.
 */
const ConfigLoadError: FC<ConfigLoadErrorProps> = ({ onRetry }) => (
  <div
    className="flex h-screen w-full flex-col items-center justify-center gap-4 px-4 text-center text-dark"
    data-testid="config-load-error"
  >
    <Icons.alertCircle className="h-12 w-12 text-error-text" />
    <Typography variant="heading2">
      <TransText i18nKey="configLoadErrorTitle" />
    </Typography>
    <Typography variant="paragraph" className="max-w-md">
      <TransText i18nKey="configLoadErrorDescription" />
    </Typography>
    <Button
      variant="secondary"
      onClick={onRetry}
      data-testid="config-load-error-retry"
      className="w-fit"
    >
      <TransText i18nKey="tryAgain" />
    </Button>
  </div>
);

export default ConfigLoadError;
